import '../index.css';
import 'react-toastify/dist/ReactToastify.css';
import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { PAGE_URLS, PresentationType } from '@constants';
import { 
  PrivateRoute,
  AdminPage, 
  ClientLogin, 
  SalesRep, 
  Client, 
  NotFound, 
  IdleTimeout,
  OneLoginInvalid,
  NotAuthorized, 
  SlideTestingPage, 
  RenderToPdfPage, 
  Upload, 
  HealthCheck,
  AddSlidePage } from '.';

const { 
  AUTHORIZE, 
  ADMIN_UPLOAD, 
  HEALTH_CHECK, 
  ADMIN_PAGE, 
  REP_TIMEOUT,
  CLIENT_LOGIN, 
  REP_SLIDES, 
  CLIENT_SLIDES, 
  CS_SLIDES,
  PDF_PAGE, 
  TESTING_PAGE,
  NOT_AUTHORIZED, 
  NOT_FOUND, 
  DOCUMENTS_PAGE, 
  CLIENT_TIMEOUT,
  ADD_SLIDE, 
  INVALID } = PAGE_URLS;

const { SLIDES_PRESENTATION, DOCUMENTS_PRESENTATION, CUSTOMER_SERVICE_PRESENTATION } = PresentationType;

function Authorize() {
    window.location.reload();
    return null;
}

// Routes are composed such that an authorized user can visit the secure pages,
// Admin users can visit admin pages and anyone can visit all the other pages (i.e. a client)
export const App = () => {
  return (
    <Switch>
      <Route exact path={AUTHORIZE}>
          <Authorize />
      </Route>
      <PrivateRoute adminRoute={true} path={ADMIN_UPLOAD}>
          <Upload />
      </PrivateRoute>
      <PrivateRoute adminRoute={true} path={HEALTH_CHECK}>
          <HealthCheck />
      </PrivateRoute>
      <PrivateRoute adminRoute={true} exact path={ADMIN_PAGE}>
          <AdminPage />
      </PrivateRoute>
      <PrivateRoute adminRoute={true} path={ADD_SLIDE} >
          <AddSlidePage />
      </PrivateRoute>
      <PrivateRoute adminRoute={true} path={TESTING_PAGE}>
          <SlideTestingPage />
      </PrivateRoute>
      <PrivateRoute path={CLIENT_LOGIN}>
          <ClientLogin />
      </PrivateRoute>
      <PrivateRoute exact path={DOCUMENTS_PAGE}>
          <SalesRep presentationType={DOCUMENTS_PRESENTATION} />
      </PrivateRoute>
      <PrivateRoute path={REP_SLIDES}>
          <SalesRep presentationType={SLIDES_PRESENTATION}/>
      </PrivateRoute>
      <PrivateRoute path={CS_SLIDES}>
          <SalesRep presentationType={CUSTOMER_SERVICE_PRESENTATION} />
      </PrivateRoute>
      <Route path={CLIENT_SLIDES}>
          <Client />
      </Route>
      <Route path={CLIENT_TIMEOUT}>
          <IdleTimeout clientViewing={true} />
      </Route>
      <Route path={REP_TIMEOUT}>
          <IdleTimeout clientViewing={false} />
      </Route>
      <Route path={PDF_PAGE}>
          <RenderToPdfPage />
      </Route>
      <Route path={NOT_AUTHORIZED}>
          <NotAuthorized />
      </Route>
      <Route path={INVALID}>
          <OneLoginInvalid />
      </Route>
      <Route path={NOT_FOUND}>
          <NotFound />
      </Route>
    </Switch>
  );
};

export default App;
